"use client";

import { logger } from "@/app/_lib/logger";
import { useEffect } from "react";

export function ConsoleBranding() {
  useEffect(() => {
    // Only log in browser
    if (typeof window === "undefined") return;

    logger.debug("open.other.console_branding_debug", {
      feature: "other",
      message:
        "%c" +
        "\n" +
        "╭─────────────────────────────╮\n" +
        "│                                                  │\n" +
        "│                             @@@@@@               │\n" +
        "│                          @@@@@@@@@@@@            │\n" +
        "│                       @@@@      @@@@@@           │\n" +
        "│                      @@          @@@@@@          │\n" +
        "│           @@@@@@@@ @             @@@@@@          │\n" +
        "│         @@@@     @@@@@@@        @@@@@@@          │\n" +
        "│          @@@@@@@@    @@@@@@@@@@@@@@@@@           │\n" +
        "│           @@@           @@@@@@@@@@@@@            │\n" +
        "│                            @@@@@@                │\n" +
        "│                                                  │\n" +
        "│                                $$  $$            │\n" +
        "│                                $$  $$            │\n" +
        "│  $$$$$$ $$$$    $$$$$$    $$$$$$$  $$  $$    $$  │\n" +
        "│  $$   $$   $$  $$    $$  $$    $$  $$  $$    $$  │\n" +
        "│  $$   $$   $$  $$$$$$$$  $$    $$  $$  $$    $$  │\n" +
        "│  $$   $$   $$  $$        $$    $$  $$  $$    $$  │\n" +
        "│  $$   $$   $$   $$$$$$$   $$$$$$$  $$   $$$$$$$  │\n" +
        "│                                              $$  │\n" +
        "│                                        $$    $$  │\n" +
        "│                                         $$$$$$   │\n" +
        "│                                                  │\n" +
        "├──────────────────────────────────────────────────┤\n" +
        "│                                                  │\n" +
        "│               Welcome to Medly! 🎓               │\n" +
        "│                                                  │\n" +
        "╰─────────────────────────────╯\n",
      args: [
        "color: #06B0FF; font-weight: bold; font-size: 12px; line-height: 1.2;",
      ],
    });
  }, []);

  return null;
}
